export default "__VITE_ASSET__CN11Qf4O__"